const PAGES = {
  dashboard: 'Dashboard',
  catalog: 'Katalog',
  details: 'Details',
  system_applications: 'Anwendungsbereiche',
  cart: 'Warenkorb',
  myaccount: 'Mein Konto',
  checkout: 'Checkout',
  overview: 'Übersicht',
  qrscanner: 'QR Scanner',
  register: 'Registrierung',
  password_forgot: 'Passwort vergessen',
  password_reset: 'Passwort ändern',
  products: 'Produkte',
  systems: 'Systeme',
  news: 'News',
  checkout_type: 'Typ wählen',
  checkout_details: 'Details',
  checkout_summary: 'Übersicht',
  qcvmixer: 'QCV Mixer',
  elasticmixer: 'Flakes Mixer',
};

export default PAGES;
